module.exports = __webpack_public_path__ + "img/proship-logo-icon.19250e3a.png";